import React from 'react'
import PIXE_ICON from '../../assets/pixe.png'

export default function TokenIcon({ symbol }: { symbol?: string }) {
  const s = (symbol || '').toUpperCase()
  if (s === 'PIXE') {
    return (
      <span className="inline-flex items-center justify-center h-9 w-9 rounded-full overflow-hidden border border-white/15 bg-white/10">
        {/* eslint-disable-next-line */}
        <img src={PIXE_ICON} alt="PIXE" className="h-full w-full object-contain" />
      </span>
    )
  }
  if (s === 'USD') {
    return (
      <span className="inline-flex items-center justify-center h-9 w-9 rounded-full border border-sky-400/60 bg-sky-500/15 text-sky-300">
        <span className="font-extrabold">$</span>
      </span>
    )
  }
  return (
    <span className="inline-flex items-center justify-center h-9 w-9 rounded-full border border-white/15 bg-white/10 text-white/90">
      <span className="font-extrabold">{s?.[0] || '?'}</span>
    </span>
  )
}
